import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  OnInit,
  output,
  viewChild,
} from '@angular/core';

import { Toast } from '../../../models/Toast';
import { SuccessToastComponent } from './success-toast/success-toast.component';
import { ErrorToastComponent } from './error-toast/error-toast.component';
import { ObservableToastComponent } from './observable-toast/observable-toast.component';
import { WarningToastComponent } from './warning-toast/warning-toast.component';

@Component({
  selector: 'shared-core-toast',
  imports: [
    SuccessToastComponent,
    ErrorToastComponent,
    WarningToastComponent,
    ObservableToastComponent,
  ],
  templateUrl: './toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent implements OnInit {
  private readonly toastWrapper = viewChild<ElementRef>('toastWrapper');

  readonly toastConfig = input.required<Toast>();

  closeToast = output<Toast>();

  ngOnInit() {
    this.toastWrapper()?.nativeElement.classList.add('animate-toast-appear');
    setTimeout(() => {
      this.toastWrapper()?.nativeElement.classList.remove('animate-toast-appear');
      // forces animations to rerun, see https://css-tricks.com/restart-css-animation/#aa-update-another-javascript-method-to-restart-a-css-animation
      void this.toastWrapper()?.nativeElement.offsetWidth;
      this.toastWrapper()?.nativeElement.classList.add('animate-toast-disappear');
    }, this.toastConfig().lifetime - 300);
  }
}
